import React from 'react';
import { connect } from 'tanok';
import { getRoom } from '@evo/chat-core';
import { CSSTransition } from 'react-transition-group';

import { ChatContainer } from './pages';

import { ChatButton } from './components/chatButton';

import { toJS } from './helpers/ImmutableToJS';

import { getSocketStore } from './../libs/utils';
import * as c from './../libs/constants';
import * as a from './../libs/actions';

// styles
import css from './app.sss';


class BesidaBaseView extends React.Component {
    openDialog = () => {
        this.props.send(a.EVENT_OPEN_DIALOG);
    }

    openRoom = (roomIdent) => {
        this.props.send(a.EVENT_OPEN_ROOM, roomIdent);
    }

    backToChatList = (newMsgInCurrentDialog, newMsgMarkShown) => {
        return () => {
            this.props.send(a.EVENT_BACK_TO_CHAT_LIST, { newMsgInCurrentDialog, newMsgMarkShown });
            this.props.send(a.TR_SEND_ANALITICS_ACTION, { action: c.ANALCS_ACTION_BACK_TO_CHATS });
        }
    }

    closeDialog = () => {
        this.props.send(a.EVENT_CLOSE_DIALOG);

        const payload = { action: c.ANALCS_ACTION_CLOSE_CHAT, params: {} };
        if (this.props.userId) payload.params.auth = true;
        else payload.params.noauth = true;

        this.props.send(a.TR_SEND_ANALITICS_ACTION, payload);
    }

    sendMsg = () => {
        if (!this.props.chatMsgText) return false;
        this.props.send(a.EVENT_BESIDA_SEND_MESSAGE, { roomIdent: this.props.currentChatRoom.room_ident });
        this.props.send(a.TR_SEND_ANALITICS_ACTION, { action: c.ANALCS_ACTION_SEND_SUCCESS });
        return void 0;
    }

    retrySendMsg = (msgId) => {
        return () => {
            const msg = this.props.currentChatRoom.history.find((m) => m.id === msgId);
            if (!(msg.isErrorOnSending || msg.body)) return false;
            this.props.send(a.EVENT_BESIDA_RETRY_SEND_MESSAGE, {
                roomIdent: this.props.currentChatRoom.room_ident,
                msgId
            });
            return void 0;
        };
    }

    retrySendFile = (msgId) => {
        return () => {
            if (!this.props.currentChatRoom.isErrorOnFilesSave) return false;
            this.props.send(a.EVENT_BESIDA_RETRY_SEND_FILE, {
                roomIdent: this.props.currentChatRoom.room_ident,
                msgId
            });
            return void 0;
        };
    }

    retrySendFileCtx = (msgId) => {
        return () => {
            const msg = this.props.currentChatRoom.history.find((m) => m.id === msgId);
            if (!msg.isErrorOnSending) return false;
            this.props.send(a.EVENT_BESIDA_RETRY_SEND_FILE_CONTEXT, {
                roomIdent: this.props.currentChatRoom.room_ident,
                msgId
            });
            return void 0;
        };
    }

    sendCtx = () => {
        this.props.send(a.EVENT_BESIDA_SEND_CONTEXT, { roomIdent: this.props.currentChatRoom.room_ident });
    }

    sendTyping = () => {
        this.props.send(a.EVENT_BESIDA_SEND_TYPING, this.props.currentChatRoom.room_ident);
    }

    markMsgRead = (roomIdent, msgId) => {
        this.props.send(a.EVENT_BESIDA_MARK_MSG_READ, {
            roomIdent,
            msgId,
        });
    }

    chatMsgChange = ({ target }) => {
        this.props.send(a.EVENT_BESIDA_MSG_CHANGE, target);
    }

    handleMainBlockKeyPress = (event) => {
        if (event.which === c.KEY_CODE_ESCAPE && this.props.visible) {
            event.preventDefault();
            this.props.send(a.EVENT_CLOSE_DIALOG);
        }
        return true;
    }

    render() {
        const { visible, onPortal, withoutButton } = this.props;

        return (
            <div
                id='mainBesidaHolder'
                key='mainBesidaNodeHolder'
                tabIndex='-1'
                onKeyDown={this.handleMainBlockKeyPress}
            >
                <CSSTransition
                    in={visible}
                    unmountOnExit
                    timeout={c.CHAT_APPEAR_TIMEOUT}
                    classNames={{
                        enter: css.enter,
                        enterActive: css.enterActive,
                        exit: css.exit,
                        exitActive: css.exitActive,
                    }}
                >
                    <ChatContainer
                        openRoom={this.openRoom}
                        closeDialog={this.closeDialog}
                        sendMsg={this.sendMsg}
                        retrySendMsg={this.retrySendMsg}
                        retrySendFile={this.retrySendFile}
                        retrySendFileCtx={this.retrySendFileCtx}
                        sendTyping={this.sendTyping}
                        sendCtx={this.sendCtx}
                        markMsgRead={this.markMsgRead}
                        chatMsgChange={this.chatMsgChange}
                        backToChatList={this.backToChatList}
                    />
                </CSSTransition>
                {!onPortal && !withoutButton && <ChatButton openDialog={this.openDialog} />}
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    userId: state.get('userId'),
    chatMsgText: state.get('chatMsgText'),
    visible: state.get('visible'),
    onPortal: state.get('onPortal'),
    currentChatRoom: getRoom(getSocketStore(state), state.get('openedRoomIdent')),
    withoutButton: state.get('withoutButton')
});


export const BesidaView = connect(mapStateToProps)(toJS(BesidaBaseView));
